import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BackendService, IGetMaintenanceResponse } from 'nr-common';

@Component({
	selector: 'nr-maintenance',
	templateUrl: './maintenance.component.html',
	styleUrls: ['./maintenance.component.scss'],
	standalone: false,
})
export class MaintenanceComponent implements OnInit, OnDestroy {
	private readonly POLLING_INTERVAL_SECONDS = 30;
	private returnUrl: string = null;
	private pollingTimeout: ReturnType<typeof setTimeout> = null;
	private isDestroyed = false;

	constructor(
		private backend: BackendService,
		private route: ActivatedRoute,
	) {
	}

	async ngOnInit() {
		this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
		await this.pollMaintenanceStatus();
	}

	ngOnDestroy() {
		this.isDestroyed = true;
		if (this.pollingTimeout !== null) {
			clearTimeout(this.pollingTimeout);
			this.pollingTimeout = null;
		}
	}

	private async pollMaintenanceStatus() {
		const response: IGetMaintenanceResponse = await this.backend.post('maintenance/get');
		const maint = response.maintenance?.start ? new Date(response.maintenance.start) : null;

		if (maint == null) {
			window.location.href = this.returnUrl ?? '';
			return;
		}

		if (this.isDestroyed) {
			return;
		}

		this.pollingTimeout = setTimeout(() => {
			this.pollMaintenanceStatus();
		}, this.POLLING_INTERVAL_SECONDS * 1000);
	}
}
